/* global jQuery */

/*
 * Enable fancybox overlay popup with custom arrows
 */
(function ($) {
	"use strict";

	$("[data-fancybox='screenshots']").fancybox({
		toolbar  : false,
		hash: false,
		clickContent: false,
		baseClass: "screenshotsGallery",
		touch: false,
		wheel: false,
		arrows: false,
		clickSlide: false,
		animationEffect: false,
		baseTpl:
		"<div class='fancybox-container' role='dialog' tabindex='-1'>" +
		"<div class='fancybox-bg'></div>" +
		"<div class='fancybox-inner'>" +
		"<div class='fancybox-stage'>" +
		"<div class='gallery-close-button'>" +
		"<button data-fancybox-close class='fancybox-button fancybox-button--close' title='{{CLOSE}}'>" +
		"<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 38 37'><path fill='#F7FAFC' fill-rule='evenodd' d='M37.257 4.73L23.565 18.424l13.692 13.693-4.564 4.564L19 22.987 5.307 36.68.743 32.116l13.693-13.693L.743 4.73 5.307.166 19 13.858 32.693.166l4.564 4.565z'/></svg>" +
		"</button>" +
		"</div>" +
		"<div class='gallery-header'>" +
		"<div class='fancybox-caption'><div class='fancybox-caption__body'></div></div>" +
		"<div class='fancybox-navigation'>{{arrows}}</div>" +
		"</div>" +
		"</div>" +
		"</div>" +
		"</div>",
		btnTpl: {
			arrowLeft:
			"<button data-fancybox-prev class='fancybox-button fancybox-button--arrow_left' title='{{PREV}}'>" +
			"<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 12'><path fill='#FFF' d='M7.415 10.293l-1.414 1.414L.294 6 6.001.293l1.414 1.414L3.123 6z'/></svg>" +
			"</button>",

			arrowRight:
			"<button data-fancybox-next class='fancybox-button fancybox-button--arrow_right' title='{{NEXT}}'>" +
			"<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 12'><path fill='#FFF' d='M.293 1.707L1.707.293 7.414 6l-5.707 5.707-1.414-1.414L4.585 6z'/></svg>" +
			"</button>"
		},
		beforeShow: function(){
			$("body, html").addClass("screenshotGalleryOpen");
		},
		afterClose: function(){
			$("body, html").removeClass("screenshotGalleryOpen");
		}
	});

}(jQuery));

/*
 * Split full name into hidden first and last name in Marketo form
 * https://developers.marketo.com/blog/add-a-full-name-field-to-a-marketo-form/
 */

// (function () {
// 	MktoForms2.whenReady(function (){
// 		function splitFullName(a,b,c){
// 			String.prototype.capitalize = function(){
// 				return this.replace( /(^|s)([a-z])/g , function(m,p1,p2){ return p1+p2.toUpperCase(); } );
// 			};
// 			document.getElementsByName(c)[0].oninput=function(){
// 				var fullName = document.getElementsByName(c)[0].value;
// 				var first, last;
// 				if((fullName.match(/ /g) || []).length ===0 || fullName.substring(fullName.indexOf(" ")+1,fullName.length) === ""){
// 					first = fullName.capitalize();
// 					last = "null";
// 				}else if(fullName.substring(0,fullName.indexOf(" ")).indexOf(".")>-1){
// 					first = fullName.substring(0,fullName.indexOf(" ")).capitalize() + " " + fullName.substring(fullName.indexOf(" ")+1,fullName.length).substring(0,fullName.substring(fullName.indexOf(" ")+1,fullName.length).indexOf(" ")).capitalize();
// 					last = fullName.substring(first.length +1,fullName.length).capitalize();
// 				}else{
// 					first = fullName.substring(0,fullName.indexOf(" ")).capitalize();
// 					last = fullName.substring(fullName.indexOf(" ")+1,fullName.length).capitalize();
// 				}
// 				document.getElementsByName(a)[0].value = first;
// 				document.getElementsByName(b)[0].value = last;
// 			};
// 			//Initial Values
// 			if(document.getElementsByName(c)[0].value.length < 2 && document.getElementsByName(b)[0].value.length.length >2 && document.getElementsByName(a)[0].value.length.length >2 ){
// 				var first = document.getElementsByName(a)[0].value.capitalize();
// 				var last = document.getElementsByName(b)[0].value.capitalize();
// 				var fullName =  first + " " + last ;
// 				console.log(fullName);
// 				document.getElementsByName(c)[0].value = fullName;
// 			}
// 		}
// 		splitFullName("FirstName","LastName","fullNameForForms");
// 	});
// }());